

import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';

import {useEditPageTools} from '../hooks/useEditPageTools';
import {useProduct} from '../hooks/useProduct.ts';

export const EditPage = () => {

    const {id: productId} = useParams();

    if (typeof productId === 'undefined') {
        throw new Error('productId is required parameter');
    }

    const { record: product, loading, updateRecord, fetchRecord } = useProduct(productId);

    const {
        mode,
        tools,
    } = useEditPageTools();


    if (loading || !product) {
        return <PlatformLoader message='Loading product...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={product.name ? product.name : product.id}
            pageNavigation={<EditPageNavigation component={product}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={product}
                        onRecordUpdate={() => {
                            // Refresh the product data from server
                            fetchRecord();
                        }}
                    />
                </Stack>
                :
                <RecordForm
                    record={product}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};